import { useEffect, useState } from "react";
import axios from "axios";
import Dashboard from "@/pages/Dashboard";
import { LeadsExecView, OLD_VIEW_REMOVAL } from "./LeadsExecView";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EXEC_VIEW_ROLES = ["super_admin", "admin", "tenant_admin", "manager"];

// Leads Dashboard: new executive view by default; old dashboard kept behind a toggle until OLD_VIEW_REMOVAL.
export const LeadsDashboardSwitch = () => {
  const [role, setRole] = useState(undefined);
  const [view, setViewState] = useState(() => localStorage.getItem("leads_dashboard_view") || "exec");
  const setView = (v) => { localStorage.setItem("leads_dashboard_view", v); setViewState(v); };
  useEffect(() => { axios.get(`${API}/auth/me`).then((r) => setRole(r.data?.role || null)).catch(() => setRole(null)); }, []);

  if (role === undefined) return <div className="h-96 rounded-xl bg-gray-100 animate-pulse" data-testid="leads-dashboard-loading" />;
  const canExec = EXEC_VIEW_ROLES.includes(role);
  if (canExec && view === "exec") return <LeadsExecView onOldView={() => setView("old")} />;
  return (
    <div className="space-y-4">
      {canExec && (
        <div className="flex flex-wrap items-center gap-3 rounded-lg border border-[#1F8A7C]/25 bg-[#F5F9F9] px-4 py-3 text-sm text-gray-700" data-testid="leads-old-view-banner">
          <span className="flex-1 min-w-[220px]">You're on the <b>old Leads Dashboard</b>. It will be removed on <b>{OLD_VIEW_REMOVAL}</b>.</span>
          <button onClick={() => setView("exec")} className="px-3 py-1.5 rounded-md bg-[#1F8A7C] hover:bg-[#18705F] text-white font-semibold transition-colors" data-testid="leads-new-view-btn">Switch to new view</button>
        </div>
      )}
      <Dashboard />
    </div>
  );
};
